import { render, staticRenderFns } from "./Advices.vue?vue&type=template&id=3f69543d&"
import script from "./Advices.vue?vue&type=script&lang=js&"
export * from "./Advices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports